// 260805nrai: DWE freigabe confirm modal (Freigeben / Bearbeiten / Abbrechen)

function todoDweCompleteModal() {
  return $('#todo_dwe_complete_modal');
}

function openTodoDweCompleteModal($link) {
  const modal = todoDweCompleteModal();
  if (!modal.length) {
    return;
  }

  const data = $link.data();
  modal.data('todoId', data.todoId);
  modal.data('editUrl', data.editUrl);
  modal.data('completeUrl', data.completeUrl);

  $('#todo_dwe_complete_title').text(data.title || '—');
  $('#todo_dwe_complete_requester').text(data.requester || '—');
  $('#todo_dwe_complete_exception_until').text(data.exceptionUntil || '—');
  $('#todo_dwe_complete_window_until').text(data.windowUntil || '—');
  $('#todo_dwe_complete_begruendung').text((data.begruendung || '').trim() || '—');

  modal.foundation('reveal', 'open');
}

function closeTodoDweCompleteModal() {
  const modal = todoDweCompleteModal();
  if (modal.length) {
    modal.foundation('reveal', 'close');
  }
}

function submitTodoDweComplete() {
  const modal = todoDweCompleteModal();
  const completeUrl = modal.data('completeUrl');
  const $form = $('#todo_dwe_complete_form');
  if (!completeUrl || !$form.length) {
    return;
  }
  $form.attr('action', completeUrl);
  if (typeof SetPageToBusy === 'function') {
    SetPageToBusy();
  }
  $form.trigger('submit');
}

// 260805nrai: same path as pencil — native click so @rails/ujs handles data-remote
function clickTodoEditLink(todoId, editUrl) {
  const editLink = todoId
    ? document.querySelector(`#tr_${todoId} a.todo-edit-link`)
    : null;
  if (editLink) {
    editLink.click();
    return;
  }

  if (!editUrl) {
    return;
  }

  // Fallback: temporary remote link (same as pencil: data-remote + rails-ujs)
  const temporary_link = document.createElement('a');
  temporary_link.href = editUrl;
  temporary_link.setAttribute('data-remote', 'true');
  temporary_link.style.display = 'none';
  document.body.appendChild(temporary_link);
  temporary_link.click();
  temporary_link.remove();
}

function editTodoFromDweCompleteModal() {
  const modal = todoDweCompleteModal();
  const editUrl = modal.data('editUrl');
  const todoId = modal.data('todoId');
  let edit_started = false;

  const start_edit = function () {
    if (edit_started) {
      return;
    }
    edit_started = true;
    clickTodoEditLink(todoId, editUrl);
  };

  // Wait until reveal is fully closed so the overlay does not race the edit load
  modal.one('closed.fndtn.reveal', start_edit);
  closeTodoDweCompleteModal();
  setTimeout(start_edit, 400);
}

function initTodosUi() {
  $(document).off('click.todoDweComplete', '.todo-dwe-complete-open')
    .on('click.todoDweComplete', '.todo-dwe-complete-open', function (event) {
      event.preventDefault();
      openTodoDweCompleteModal($(this));
    });

  $(document).off('click.todoDweCompleteCancel', '#todo_dwe_complete_cancel')
    .on('click.todoDweCompleteCancel', '#todo_dwe_complete_cancel', function (event) {
      event.preventDefault();
      closeTodoDweCompleteModal();
    });

  $(document).off('click.todoDweCompleteEdit', '#todo_dwe_complete_edit')
    .on('click.todoDweCompleteEdit', '#todo_dwe_complete_edit', function (event) {
      event.preventDefault();
      editTodoFromDweCompleteModal();
    });

  $(document).off('click.todoDweCompleteConfirm', '#todo_dwe_complete_confirm')
    .on('click.todoDweCompleteConfirm', '#todo_dwe_complete_confirm', function (event) {
      event.preventDefault();
      submitTodoDweComplete();
    });
}

export {
  initTodosUi,
  openTodoDweCompleteModal,
  closeTodoDweCompleteModal
};
